import React from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { postAPI_Users_ForgotPassword } from '../../../../../../constants/APIs';
import { NotificationManager } from "../../../../../../components/common/react-notifications";

export default function GenerateResetPasswordLink({
  email
}) {

  const handleCopy = (email) => {
    let data = {
      email: email
    }
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Users_ForgotPassword}`,
      data: data,
    }).then(resnew => {
      navigator.clipboard.writeText(resnew.data.url);
      NotificationManager.success(
        "",
        "Link copied to clipboard.",
        3000,
        null,
        null,
        "success"
      );
    }).catch(err => console.error(err));
  };

  return (

    <Button
      color="primary"
      size="sm"
      onClick={() => handleCopy(email)}
    >
      Reset Password Link
    </Button>

  );
}
